import { API_AMOCRM } from "./api";

export const getCompanies = () => {
    return API_AMOCRM.get('companies');
}

export const companiesQuery = (query) => {
    return API_AMOCRM.get(`amo/companies?query=${query}`);
}